import { warehouseGoogleMapStyles } from "@insite/content-library/Components/WarehouseGoogleMap";
import { css } from "styled-components";

warehouseGoogleMapStyles.infoWindowLeftGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

warehouseGoogleMapStyles.infoWindowRightGridItem = {
    width: 10,
    css: css`
        margin-top: 8px;
        flex-direction: row;
        justify-content: space-between;
    `,
};
